module.exports = __webpack_public_path__ + "media/images/icons/ic-conference-47f35067e89afc0ea9e6f19ff115a439.svg";